/* import __COLOCATED_TEMPLATE__ from './search-result-entries.hbs'; */
import Component from "@ember/component";

export default Component.extend({
  tagName: "",
});
